export default function() {
  return {
    require: '^stTable',
    scope: {
      onFilter: '='
    },
    link: function(scope, element, attr, ctrl) {
      scope.$watch(
        ctrl.getFilteredCollection,
        function(newValue, oldValue) {
          scope.onFilter(ctrl);
        },
        true
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/onFilter/index.js